import React, {Component} from 'react'
import {Map, TileLayer, Marker, Popup} from 'react-leaflet'
import SearchAdress from '../SearchAdress/SearchAdress'

export default class Somemap extends Component {
    state = {}

    componentDidMount() {
        this.zoom()
    }

    zoom = () => {
        let zoomPlus = document.querySelector('.leaflet-control-zoom-in')
        let zoomMinus = document.querySelector('.leaflet-control-zoom-out')
        zoomPlus.addEventListener('click', this.props.countPlus)
        zoomMinus.addEventListener('click', this.props.countMinus)
    }

    render() {

        return (
            <div className={this.props.classNameProps}
                 onClick={this.props.showMapFuncProps}>
                <div className="leafletBox"
                     onClick={(event) => event.stopPropagation()}>
                    <SearchAdress
                        divClassProps={'searchAddress'}
                        boxClassProps={'searchAddress__box'}
                        inputClassProps={'searchAddress__input'}
                        addressProps={this.props.addressProps}
                        addressArrProps={this.props.addressArrProps}
                        chooseAddressFuncProps={this.props.chooseAddressFuncProps}
                        handleChangeFuncProps={this.props.handleChangeFuncProps}
                        showSubListAddress={this.props.showSubListAddress}
                        showSubListAddressFunc={this.props.showSubListAddressFunc}/>
                    <img className="leaflet-imgBack"
                         onClick={this.props.showMapFuncProps}
                         src={this.props.imgSrcProps}
                         alt=""/>
                    <Map center={this.props.position} zoom={this.props.zoom}>
                        <TileLayer
                            attribution='&amp;copy <a href=" http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker
                            draggable={this.props.draggable}
                            onDragend={this.props.onDragend}
                            position={this.props.markerPosition}
                            ref={this.props.refProps}>
                            <Popup minWidth={90}>
            <span onClick={this.props.toggleDraggable}>
              {this.props.draggable ? 'Перетащите маркер на нужную точку' : 'MARKER FIXED'}
            </span>
                            </Popup>
                        </Marker>
                    </Map>
                </div>
            </div>
        )
    }
}
